module.exports = __webpack_public_path__ + "logotypoidea.e24f1733.png";